module.exports = __webpack_public_path__ + "img/eagle.a42fee7c.svg";